import React from 'react';
import Navbar from './Navbar';
import FilterBar from './FilterBar';

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen bg-gray-50">
            <div className="sticky top-0 z-30">
                <Navbar />
                <FilterBar />
            </div>
            <main className="pt-6 pb-24 max-w-7xl mx-auto">
                {children}
            </main>
        </div>
    );
};

export default Layout;
